'use client'

import { createToaster, Portal, Toast, Toaster as ChakraToaster } from '@chakra-ui/react'

export const toaster = createToaster({
    placement: 'bottom',
    pauseOnPageIdle: true,
})

export const Toaster = () => {
    return (
        <Portal>
            <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
                {(toast) => <Toast.Root width={{ md: 'sm' }}>{toast.meta!.render()}</Toast.Root>}
            </ChakraToaster>
        </Portal>
    )
}
